import { render, staticRenderFns } from "./LiveBigBannerCatalog.vue?vue&type=template&id=490ea370&scoped=true"
import script from "./LiveBigBannerCatalog.vue?vue&type=script&lang=js"
export * from "./LiveBigBannerCatalog.vue?vue&type=script&lang=js"
import style0 from "./LiveBigBannerCatalog.vue?vue&type=style&index=0&id=490ea370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ea370",
  null
  
)

export default component.exports